import { AxiosResponse } from 'axios';

import { CreateTagRequestType, FetchTagRequestType } from './types';

import { CommonResponseType } from 'api/authApi';
import { GeneralResponseType } from 'common';
import { authServiceClient } from 'config';
import { TagType } from 'state';

export const fetchTagsRequest = (params?: FetchTagRequestType) => {
  return authServiceClient.get<
    GeneralResponseType<TagType>,
    AxiosResponse<GeneralResponseType<TagType>>,
    FetchTagRequestType
  >(`/timecode-tag`, { params });
};

export const createTagRequest = (data: CreateTagRequestType) => {
  return authServiceClient.post<TagType, AxiosResponse<TagType>, CreateTagRequestType>(
    `/timecode-tag`,
    data,
  );
};

export const deleteTagRequest = (id: string) => {
  return authServiceClient.delete<CommonResponseType, AxiosResponse<CommonResponseType>>(
    `/timecode-tag/${id}`,
  );
};
